export const synthesesConstants = {
    SYNTHESE_FICHE_INTERVENTION_FETCH_REQUEST: "SYNTHESE_FICHE_INTERVENTION_FETCH_REQUEST",
    SYNTHESE_FICHE_INTERVENTION_FETCH_SUCCESS: "SYNTHESE_FICHE_INTERVENTION_FETCH_SUCCESS",
    SYNTHESE_FICHE_INTERVENTION_FETCH_FAILURE: "SYNTHESE_FICHE_INTERVENTION_FETCH_FAILURE",

};
